import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, User, Menu, X, ShieldCheck } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAdmin } = useAuth();

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-14 sm:h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="text-xl sm:text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
              <span className="text-gray-900">Clarity</span>
              <span className="text-blue-600">.</span>
            </div>
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>

          {/* Desktop Search & User */}
          <div className="hidden lg:flex items-center flex-1 max-w-xl mx-8">
            <div className="relative w-full">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search news..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                data-testid="search-input"
              />
            </div>
          </div>

          <div className="hidden lg:flex items-center space-x-4">
            {isAdmin && (
              <Link
                to="/admin"
                className="flex items-center space-x-2 px-4 py-2 rounded-full hover:bg-gray-100 text-amber-700"
                data-testid="admin-link"
              >
                <ShieldCheck className="w-5 h-5" />
                <span>Admin</span>
              </Link>
            )}
            <Link 
              to="/profile" 
              className="flex items-center space-x-2 px-4 py-2 rounded-full hover:bg-gray-100"
              data-testid="profile-link"
            >
              <User className="w-5 h-5" />
              <span>Profile</span>
            </Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            {/* Mobile Search */}
            <div className="relative mb-4">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                type="text"
                placeholder="Search news..."
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            {isAdmin && (
              <Link
                to="/admin"
                className="flex items-center justify-center space-x-2 px-4 py-2 bg-amber-50 text-amber-700 border border-amber-200 rounded-lg hover:bg-amber-100 w-full mb-2"
                onClick={() => setMobileMenuOpen(false)}
                data-testid="admin-link-mobile"
              >
                <ShieldCheck className="w-5 h-5" />
                <span>Admin</span>
              </Link>
            )}

            {/* Mobile Sign In */}
            <Link 
              to="/profile" 
              className="flex items-center justify-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 w-full"
              onClick={() => setMobileMenuOpen(false)}
            >
              <User className="w-5 h-5" />
              <span>Profile</span>
            </Link>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
